import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { SubscriptionItemService } from 'src/app/core/services/subscription-item.service';
import { CustomerSubscriptionItem } from 'src/app/shared/models/CustomerSubscription.item';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';

@Component({
	selector: 'app-checkout-cart',
	templateUrl: './checkout-cart.component.html',
	styleUrls: ['./checkout-cart.component.scss'],
})
export class CheckoutCartComponent implements OnInit, OnDestroy {
	cartItems: CustomerSubscriptionItem[];

	cartItemSubscription: Subscription;

	constructor(public app: AppService, public subscriptionItemService: SubscriptionItemService) {}
	ngOnDestroy(): void {
		this.cartItemSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.cartItemSubscription = this.subscriptionItemService.cartItems.subscribe((data) => {
			this.cartItems = data;
		});
		this.cartItems = this.subscriptionItemService.cartItems.value;
		console.log(this.cartItems);
	}

	removeItemPrompt(item: CustomerSubscriptionItem, index: number) {
		this.app.confirmation.confirm({
			message: `Remove ${item.ooMenuItem.name} from your cart?`,
			accept: async () => {
				this.removeItemFromCart(item, index);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	removeItemFromCart(item: CustomerSubscriptionItem, index: number) {
		this.subscriptionItemService.cartItems.value.splice(index, 1);
		this.subscriptionItemService.cartItems.next(this.subscriptionItemService.cartItems.value);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `${item.ooMenuItem.name} removed from cart` });
	}
}
